import styled from 'styled-components';

const Wrapper = styled.div`
  position: relative;
`;

const TargetWrapper = styled.div`
  cursor: pointer;
`;

const ContentWrapper = styled.div`
  position: absolute;
  min-width: fit-content;
  width: 100%;
  top: 0;
  right: 0;
  z-index: 1000;
  
  &.user-dropdown {
    top: 35px;
  }
  
  &.closed {
    display: none;
  }
  &.open {
    display: flex;
  }
`;

export default { Wrapper, TargetWrapper, ContentWrapper };
